import LinkButton from '@/decodo/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';

import { HeaderItem } from './HeaderItem';
import { LanguageToggle } from './LanguageToggle';

type ExtraLinksProps = {
  links: LinkButtonStrapiProps[];
  showRegionToggle: boolean;
  hoveredLinkTitle: string;
  onLinkHover: (title?: string) => void;
  onLinkHoverCancel: (title?: string) => void;
};

export function ExtraLinks({
  links,
  showRegionToggle,
  hoveredLinkTitle,
  onLinkHover,
  onLinkHoverCancel,
}: ExtraLinksProps) {
  return (
    <ul className='headerLg:flex  hidden shrink-0 items-center gap-x-6'>
      {showRegionToggle && (
        <li
          className='group/header-list-item z-50 self-stretch'
          data-hovered={!!hoveredLinkTitle && hoveredLinkTitle !== 'Region'}
          onMouseEnter={() => onLinkHover('Region')}
          onMouseLeave={() => onLinkHoverCancel()}
        >
          <LanguageToggle />
        </li>
      )}
      {links.map((link) =>
        link.text ? (
          <ExtraLinkItem
            key={link.url}
            link={{ ...link, text: link.text! }}
            hoveredLinkTitle={hoveredLinkTitle}
            onLinkHover={onLinkHover}
            onLinkHoverCancel={onLinkHoverCancel}
          />
        ) : null
      )}
    </ul>
  );
}

type ExtraLinkItemProps = {
  link: LinkButtonStrapiProps & { text: string };
} & Pick<
  ExtraLinksProps,
  'hoveredLinkTitle' | 'onLinkHover' | 'onLinkHoverCancel'
>;

function ExtraLinkItem({
  link,
  hoveredLinkTitle,
  onLinkHover,
  onLinkHoverCancel,
}: ExtraLinkItemProps) {
  if (link.variant === 'outlined') {
    return (
      <li className='dark'>
        <LinkButton href={link.url} variant='outlined' color='secondary'>
          {link.text}
        </LinkButton>
      </li>
    );
  }

  const extraLinksDataTracker = `header-button-${link.text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')}`;

  return (
    <li
      className='group/header-list-item'
      data-hovered={!!hoveredLinkTitle && hoveredLinkTitle !== link.text}
      onMouseEnter={() => onLinkHover(link.text)}
      onMouseLeave={() => onLinkHoverCancel(link.text)}
    >
      <HeaderItem
        href={link.url}
        showDropdown={false}
        title={link.text}
        data-tracker={extraLinksDataTracker}
      />
    </li>
  );
}
